import React from 'react';
import clsx from 'clsx';
import Text from '@/components/ui/Text';
import styles from './index.module.scss';

interface SectionProps {
  children: React.ReactNode;
  headerColorClass: string;
  headerIcon: React.ReactNode;
  headerLink?: React.ReactNode;
  headerTitle: string;
  isEmpty?: boolean;
}

const Section = ({ children, headerColorClass, headerIcon, headerLink, headerTitle, isEmpty }: SectionProps) => (
  <div className={`${styles.container} ${isEmpty ? 'tw-bg-white' : 'tw-bg-[#eeeeee]'}`}>
    <div className={`tw-flex tw-justify-between tw-text-white tw-text-lg tw-font-bold
      ${headerColorClass} ${styles.cardTitle}`}
    >
      <div className="tw-flex tw-flex-1 tw-items-center tw-min-w-[10rem] tw-pl-5">
        {headerIcon}
        <Text tag="h2" variant="heading2">{headerTitle}</Text>
      </div>
      <div className="tw-flex-shrink-0 tw-pr-3 tw-ml-auto">{headerLink}</div>
    </div>
    <div className={clsx(styles.cardBody, { [styles.message]: isEmpty })}>
      {children}
    </div>
  </div>
);

export default Section;
